import { Container, styled, Box, Grid } from '@mui/material';
import { GREEN_LOGO, WHITE, BLUE_LIGHT_RGB_BORDER, BLUE_DARK, BLACK, GREEN_MAIN } from '../../theme/colors';
import { isMobile } from 'react-device-detect';
import { breakpoints } from '../../theme/breakpoints';


interface HeaderContainerProps {
  isScrolled?:boolean
  menuMobileOpen?: boolean
}
  
export const HeaderContainer = styled('div')<HeaderContainerProps>(({theme, isScrolled=false, menuMobileOpen=false})=>({
  top:'0px',
  left:'0px',
  right:'0px',
  position:'fixed',
  display:'flex',
  height: !isMobile ? (!isScrolled ? '180px' : '70px') : (menuMobileOpen ? '120px' : '70px'),
  flexDirection: !isMobile ? (!isScrolled ? 'column' : undefined): 'column',
  backgroundColor:WHITE,
  [theme.breakpoints.down('md')]: {
    borderBottom: "1px solid " + GREEN_LOGO,
  },
  borderBottom: isScrolled ? "1px solid " + GREEN_LOGO : 'none',
  zIndex:100,
  transition: !isMobile ? 'height 0.3s ease' : undefined,
}))

export const HeaderContainerNotScrolled = styled('div')(({theme})=>({
  top:'0px',
  left:'0px',
  right:'0px',
  position:'fixed',
  display:'flex',
  height: '70px',
  flexDirection: 'column',
  backgroundColor:WHITE,
  [theme.breakpoints.down('md')]: {
    
  },
  borderBottom: "1px solid " + GREEN_LOGO,
  zIndex:100,
  transition:undefined,
}))

export const ContainerHiddenSubHeader = styled('div')<HeaderContainerProps>(({theme, isScrolled=false})=>({
  width:'100%',
  display: !isMobile ? (!isScrolled ? 'flex' : 'none') : 'none',
  height:!isScrolled ? '35px' : '0px',
  backgroundColor:WHITE,
  alignItems:'center',
  padding:'8px 0 0 0',
  transition: 'height 0.3s ease', 
}))

export const Logo = styled('img')<HeaderContainerProps>(({theme, isScrolled=false})=>({
  height: !isMobile ? (!isScrolled ? '120px' : '50px') : '40px',
  marginTop:!isMobile ? (!isScrolled ? '-35px': '0px') : '0px',
  transition: 'height 0.5s ease', 
  [theme.breakpoints.down('md')]: {
    marginTop: !isMobile ? '0px' : undefined,
    height: !isMobile ? (!isScrolled ? '90px' : '50px') : '40px',
  },
  [theme.breakpoints.only('xs')]: {
    marginTop: !isMobile ? '0px' : undefined,
    height: !isMobile ? (!isScrolled ? '60px' : '50px') : '40px',
  },
}))

export const GridLogin = styled(Grid)(({theme})=>({
  width:'120px',
  display:'flex',
  justifyContent:'center',
  alignItems:'center',
  padding:'0px !important',
  [theme.breakpoints.only('xs')]:{
    width:'100px'
  }
}))

export const GridMenu = styled(Grid)(({theme})=>({
  width:'100px',
  display:'flex',
  justifyContent:'center',
  alignItems:'center',
  padding:'0px !important',
  [theme.breakpoints.up('xs')]:{
    
  }
}))


interface GridDimensionProps {
  breackpoint: keyof typeof breakpoints.values
}
export const GridMenuHiddenDown = styled(Grid)<GridDimensionProps>(({theme,breackpoint})=>({
  // width:'auto !important',
  fontSize:'1.1rem',
  '&:hover': {
    color: BLUE_DARK,
  },
  '&.selected': {
    color: BLUE_DARK,
  },
  [theme.breakpoints.down(breackpoint)]:{
    display:'none'
  },

  [theme.breakpoints.up(breackpoint)]:{
    // width:'100px',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    padding:'0 5px !important',
  }
}))

export const GridMenuHiddenUp = styled(Grid)<GridDimensionProps>(({theme,breackpoint})=>({
  fontSize:'0.85rem',
  '&:hover': {
    color: BLUE_DARK,
  },
  '&.selected': {
    color: BLACK,
    
  },

  [theme.breakpoints.up(breackpoint)]:{
    display:'none'
  },

  [theme.breakpoints.down(breackpoint)]:{
    // width:'100px',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    padding:'0 5px !important',
  }
}))
  